<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)" >
    <div class="conteudoGeral-view">
      <div class="auto-container" v-if="(tipo === 'politicaDePrivacidade')">
        <div class="title-group">
          <span class="sectionTitle" v-html="fc_getText(null, tipo)"></span>
          <div class="subtitulo" v-html="item.titulo"></div>
        </div>
        <div class="conteudoGeralText" style="margin-bottom:20px !important;" v-html="item.conteudo"></div>
        <div class="block-temas">
          <div v-for="(forItem, forIndex) in item.temas" :key="forIndex" :item="forItem" >
            <div class="tema mb-2" v-html="forItem.titulo" @click="mt_redirectTema(forItem)"></div>
          </div>
        </div>
        <div class="btn flex mt-4 mb-6" v-if="(item.anexo != null)">
          <div @click="fc_dialogPdf(item.anexo, item.anexoNome.toUpperCase())" class="flex btn-redireciona" v-html="fc_getText(null, 'btn_verDocumento')"></div>
        </div>
      </div>
      <div class="auto-container" v-if="(tipo !== 'politicaDePrivacidade')">
        <div class="title-group">
          <span class="sectionTitle" v-html="fc_getText(null, tipo)"></span>
          <div class="subtitulo" v-html="item.titulo"></div>
        </div>
        <div class="conteudoGeralText" v-html="item.conteudo"></div>
        <div class="btn flex mt-4 mb-6" v-if="(item.anexo != null)">
          <div @click="fc_dialogPdf(item.anexo, item.anexoNome.toUpperCase())" class="flex btn-redireciona" v-html="fc_getText(null, 'btn_verDocumento')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loaded: false,
      item: {},
      tipo: null,
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.tipo = this.$route.name;
      if (this.tipo == null) { this.mt_goBack(); }
      else { this.mt_loadData(); }
    },
    mt_loadData() {
      this.loaded = false;
      this.fc_fetch({ endpoint: 'ConteudosGerais/' + this.tipo + '/', method: 'GET', success: this.mt_loadData_success, error: () => { this.mt_goBack(); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.item != null) {
        this.item = response.item;
        this.loaded = true;
      } else {
        this.mt_goBack();
      }
    },
    mt_goBack() {
      this.fc_goRoute('home');
    },
    mt_redirectTema(tema) {
      if (tema.visualizacao == 1) {
        this.fc_goRoute('conteudoGeralTema', { id: tema.id })
      } else if (tema.visualizacao == 2) {
        this.fc_dialogPdf(tema.anexo, tema.titulo.toUpperCase())
      }
    }
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.conteudoGeral-view {
  padding-top: 150px;
}
.conteudoGeralText {
  margin-bottom: 65px;
}
.title-group {
  margin-bottom: 35px;
}
.block-temas {
  margin: 15px 15px;
  margin-bottom:65px;
}
.block-temas .tema {
  font-size: 16px;
  font-weight: bold;
  cursor:pointer;
}
.block-temas .tema:hover {
  color: var(--ibase-color);
}
</style>
